import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M27.0752 1.2475L1.87523 24.3775C-1.05477 27.3075 2.26523 26.7475 5.79523 26.7475C6.54523 26.7475 7.16523 27.3575 7.16523 28.1175V55.6975C7.16523 56.4475 7.77523 57.0675 8.53523 57.0675H20.2752C21.0252 57.0675 21.6452 56.4575 21.6452 55.6975V41.7075C21.6452 40.9575 22.2552 40.3375 23.0152 40.3375H33.7852C34.5352 40.3375 35.1552 40.9475 35.1552 41.7075V55.6975C35.1552 56.4475 35.7652 57.0675 36.5252 57.0675H48.2652C49.0152 57.0675 49.6352 56.4575 49.6352 55.6975V28.1175C49.6352 27.3675 50.2452 26.7475 51.0052 26.7475C54.5352 26.7475 57.8552 27.2975 54.9252 24.3775L29.7052 1.2475C29.7052 1.2475 28.4652 0.127497 27.0652 1.2475H27.0752Z",
		transform: "translate(3.53 3.87)",
		stroke: "#311123",
		strokeWidth: 1.5,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M43.1141 18.8056L23.0541 0.395556C23.0541 0.395556 22.0641 -0.494444 20.9541 0.395556L0.894122 18.8056C-1.21588 20.9156 0.754122 20.7556 3.22412 20.7056V49.5256C3.22412 50.0256 3.63412 50.4356 4.13412 50.4356H11.9841C12.4841 50.4356 12.8941 50.0256 12.8941 49.5256V36.7556C12.8941 34.9256 14.3841 33.4356 16.2141 33.4356H27.9541C29.6541 33.4356 31.0341 34.8156 31.0341 36.5156V49.5156C31.0341 50.0156 31.4441 50.4256 31.9441 50.4256H39.7941C40.2941 50.4256 40.7041 50.0156 40.7041 49.5156V20.6956C43.2141 20.7456 45.2341 20.9256 43.1041 18.7956L43.1141 18.8056Z",
		transform: "translate(10.00 8.26)",
		fill: "#FF6047"
	})]
});
export default SvgSlHome;
